import { AGENTIC_CHAT_BOT_ACTIONS } from "./agenticchatbot.thunk";

const initialState: any = {
  previousConversations: {},
  showConversationHistory: false,
  messages: [],
};

export default function agenticChatBotReducer(
  state = initialState,
  action: any
) {
  switch (action.type) {
    case AGENTIC_CHAT_BOT_ACTIONS.UPDATE_SHOW:
      state = {
        ...state,
        showConversationHistory: action.payload,
      };

      return state;

    case AGENTIC_CHAT_BOT_ACTIONS.GET_PREVIOUS_CONVERSATIONS:
      state = {
        ...state,
        previousConversations: action.payload,
      };
      return state;

    case AGENTIC_CHAT_BOT_ACTIONS.SET_MESSAGES:
      state = {
        ...state,
        messages: action.payload,
      };
      return state;
    default:
      return state;
  }
}
